const { produce } = require("immer");

const init = {
  invitationUid: null
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_guestForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
        if(action.form.invitation) draft.invitationUid = action.form.invitation;
      });

    case "UPDATE_guestForm":
      return produce(state, draft => {
        Object.assign(draft, action.form);
      });

    case "RESET_guestForm":
      return init;

    default:
      return state;
  }
}
